// extracted by mini-css-extract-plugin
module.exports = {"Heading":"_12oDh"};